<template>
  <div class="leftBottom">
    <div class="title" :class="menuItem.logisticsTransRank ? 'setCursor' : ''" @click="showModel">物流</div>
    <div class="list">
      <!-- <div class="item">
        <img class="icon" src='@/assets/images/home/icon-qysl.png' />
        <div>
          <div class="text">企业数量</div>
          <div class="num">{{ summary.companyQuantity || 0 | formatNumber }}<span>个</span></div>
        </div>
      </div> -->
      <div class="item">
        <img class="icon" src='@/assets/images/home/icon-yszl.png' />
        <div>
          <div class="text">运输重量</div>
          <div class="num">{{ topSummary.totalWeight || 0 | formatNumber }}<span>kg</span></div>
        </div>
      </div>
      <div class="item">
        <img class="icon" src='@/assets/images/home/icon-ydsl.png' />
        <div>
          <div class="text">运单数量</div>
          <div class="num">{{ topSummary.shipNum || 0 | formatNumber }}<span>单</span></div>
        </div>
      </div>
    </div>
    <div id="leftBottom-charts"></div>
  </div>
</template>

<script>
import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import apiPath from '@config/api.json'
const { mapState, mapMutations } = require('vuex')
export default {
  components: {},

  data () {
    return {
      menuItem: {
        logisticsTransRank: false // 物流机构运输量TOP排名
      },
      formData: {},
      topSummary: {},
      waybill: [],
      summary: {},
      myChart: null, // 图表对象
      initObj: null // 用于定时器处理
    }
  },

  computed: {
    ...mapState({
      homeTime: (state) => {
        return state.home.homeTime
      }
    })
  },

  watch: {
    homeTime: function (n) {
      this.init()
    }
  },

  created () {
    // this.setLanguageMsg(this.lan)
    const getListMenu = common.getListMenu()
    if (getListMenu) {
      const setListMenu = window.JSON.parse(getListMenu)
      this.menuItem.logisticsTransRank = common.isShowItem('logisticsTransRank', setListMenu)
    }
  },

  mounted () {
    var chartDom = document.getElementById('leftBottom-charts')
    this.myChart = this.$echarts.init(chartDom)
    this.init()
    this.initDialogTotalData()
    this.initObj = setInterval(() => {
      this.init()
      this.initDialogTotalData()
    }, 60000)
  },

  methods: {
    ...mapMutations(['setModelInfo']),
    init () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.home.leftBottom.getLogisticsStatistics}`,
        parmas: {
          pageIndex: 1,
          pageSize: 10
          // yearTime: this.homeTime
        }
      }).then(res => {
        if (res && res.data.length) {
          let dataInfo = res.data
          this.summary = dataInfo || []
          // this.topSummary = dataInfo.transportQuantityTopSummary || {}
          // this.waybill = dataInfo.waybillQuantityTopSummary || []
        }
        this.initCharts()
      })
    },
    initDialogTotalData () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.home.getLogisticStatistics}`,
        data: {
          pageNum: 1,
          pageSize: 10
          // yearTime: this.homeTime
        }
      }).then(res => {
        if (res && res.data) {
          let dataInfo = res.data
          this.topSummary = dataInfo || {}
        }
        this.initCharts()
      })
    },
    initCharts () {
      this.myChart && this.myChart.clear()
      if (!this.summary.length) return
      let shipNum = []
      let totalWeight = []
      for (let i = 0; i < 12; i++) {
        let monthNum = i + 1 <= 9 ? ('0' + (i + 1)) : i + 1
        for (let e of this.summary) {
          if (!e.monthDay.split('-')[1].includes(monthNum)) continue
          shipNum[i] = e.shipNum
          totalWeight[i] = e.totalWeight
        }
        if (!shipNum[i]) {
          shipNum[i] = 0
        }
        if (!totalWeight[i]) {
          totalWeight[i] = 0
        }
      }
      var option

      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: 'rgba(227, 242, 252, 0.39)',
              width: 25,
              type: 'solid'
            },
            z: 0 // 注意要设置层级，不然会在覆盖在柱子前面，设置为0就在柱子后面显示了。
          }
        },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        grid: {
          left: 10,
          right: 0,
          bottom: 0,
          top: 27,
          containLabel: true
        },
        series: [
          {
            data: shipNum,
            type: 'bar',
            name: '运单数量',
            barWidth: 10,
            showBackground: false,
            // backgroundStyle: {
            //   color: rgba(116,142,135,0.2)
            // },
            itemStyle: {
              normal: {
                color: function (parmas) {
                  let colorList = ['#6295f6', '#6295f6', '#6295f6', '#6295f6', '#6295f6', '#6295f6', '#6295f6', '#6295f6', '#6295f6', '#6295f6', '#6295f6', '#6295f6']
                  return colorList[parmas.dataIndex]
                }
              }
            },
            label: {
              // 柱图头部显示值
              show: false,
              position: 'top',
              color: '#ffffff',
              fontSize: '10px',
              textStyle: {
                color: '#ffffff',
                fontSize: 12
              }
            }

          },
          {
            data: totalWeight,
            type: 'bar',
            name: '运输重量',
            barWidth: 10,
            showBackground: false,
            // backgroundStyle: {
            //   color: rgba(116,142,135,0.2)
            // },
            itemStyle: {
              normal: {
                color: function (parmas) {
                  let colorList = ['#51b2bb', '#51b2bb', '#51b2bb', '#51b2bb', '#51b2bb', '#51b2bb', '#51b2bb', '#51b2bb', '#51b2bb', '#51b2bb', '#51b2bb', '#51b2bb']
                  return colorList[parmas.dataIndex]
                }
              }
            },
            label: {
              // 柱图头部显示值
              show: false,
              position: 'top',
              color: '#ffffff',
              fontSize: '10px',
              textStyle: {
                color: '#ffffff',
                fontSize: 12
              }
            }

          }
        ]
      }
      option && this.myChart.setOption(option)
    },
    showModel () {
      if (!this.menuItem.logisticsTransRank) return
      let that = this
      this.setModelInfo({
        modelUrl: 'getLogisticStatistics',
        // title: '物流企业运输量TOP排名',
        title: '企业物流数据统计',
        headList: [
          {
            name: '物流企业',
            value: that.topSummary.orgNum || 0,
            unit: '（家）'
          }, {
            name: '运输总重量',
            value: that.topSummary.totalWeight || 0,
            unit: '（kg）'
          }, {
            name: '运单数量',
            value: that.topSummary.shipNum || 0,
            unit: '（单）'
          }
        ],
        model: true,
        method: 'post'
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.initObj)
  }
}
</script>

<style lang="scss" scoped>
.leftBottom {
  width: 454px;
  height: 214px;
  background: url('~@/assets/images/home/title-bg.png') no-repeat 0 0;
  background-size: 100% 100%;

  .title {
    height: 18px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #00FAFF;
    width: 100%;
    line-height: 18px;
    margin-top: 10px;
    text-align: center;
  }

  .list {
    display: flex;
    justify-content: space-between;
    margin: 12px 18px 0 18px;

    .item {
      display: flex;
      align-items: center;

      .icon {
        width: 34px;
        height: 34px;
      }

      .text {
        font-size: 10px;
        line-height: 10px;
        margin-bottom: 4px;
      }

      .num {
        font-size: 14px;
        line-height: 14px;

        // color:#30FDFF;
        span {
          font-size: 10px;
          line-height: 10px;
        }
      }
    }
  }

  #leftBottom-charts {
    margin: 0px 18px 0 18px;
    width: 420px;
    height: 130px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/home/compontents/leftBottom.vue